import { Aggregator } from './aggregator';

export interface TransactionDates {
  debitedAt?: string;
  bookedAt?: string;
}

export enum TransactionIncomeCategory {
  ALLOWANCE = 'ALLOWANCE',
  ALLOWANCE_FAMILY = 'ALLOWANCE_FAMILY',
  ALLOWANCE_HOUSING = 'ALLOWANCE_HOUSING',
  ALLOWANCE_UNEMPLOYMENT = 'ALLOWANCE_UNEMPLOYMENT',
  ALLOWANCE_HEALTH = 'ALLOWANCE_HEALTH',
  ALLOWANCE_DISABILITY = 'ALLOWANCE_DISABILITY',
  ALLOWANCE_INCOME_SUPPORT = 'ALLOWANCE_INCOME_SUPPORT',
  STATE_SUBSIDY = 'STATE_SUBSIDY',
  GAMBLING_GAIN = 'GAMBLING_GAIN',
  RENTAL_INCOME = 'RENTAL_INCOME',
  RECEIVED_ALIMONY = 'RECEIVED_ALIMONY',
  WAGE = 'WAGE',
  WAGE_BONUS = 'WAGE_BONUS',
  WAGE_SALARY_ADVANCE = 'WAGE_SALARY_ADVANCE',
  WAGE_ADVANCE_PAYMENT = 'WAGE_ADVANCE_PAYMENT',
  FREELANCE = 'FREELANCE',
  RETIREMENT_PENSION = 'RETIREMENT_PENSION',
  DISSAVING = 'DISSAVING',
  OTHER_ENTRY = 'OTHER_ENTRY',
  REGULAR_INCOME = 'REGULAR_INCOME',
  REVERSIONARY_PENSION = 'REVERSIONARY_PENSION',
}

export enum TransactionExpenseCategory {
  INSURANCE = 'INSURANCE',
  PAID_ALIMONY = 'PAID_ALIMONY',
  INSURANCE_HEALTH = 'INSURANCE_HEALTH',
  INSURANCE_AUTO = 'INSURANCE_AUTO',
  INSURANCE_HOME = 'INSURANCE_HOME',
  INSURANCE_LOAN = 'INSURANCE_LOAN',
  TRANSPORT = 'TRANSPORT',
  POWER = 'POWER',
  RENT = 'RENT',
  TELECOM = 'TELECOM',
  HEALTH = 'HEALTH',
  GROCERY = 'GROCERY',
  TOBACCO = 'TOBACCO',
  GAMBLING = 'GAMBLING',
  LEISURE = 'LEISURE',
  SHOPPING = 'SHOPPING',
  DEFERRED_TOTAL_PAYMENT = 'DEFERRED_TOTAL_PAYMENT',
  MULTIMEDIA = 'MULTIMEDIA',
  SPORT = 'SPORT',
  OTHER_EXPENSE = 'OTHER_EXPENSE',
  REGULAR_EXPENSE = 'REGULAR_EXPENSE',
  /** @deprecated Created for backward compatibility on V1 folder */
  ATM = 'ATM',
  /** @deprecated Created for backward compatibility on V1 folder */
  CARD_PAYMENT = 'CARD_PAYMENT',
  /** @deprecated Created for backward compatibility on V1 folder */
  CHECK = 'CHECK',
}

export enum TransactionCreditCategory {
  LOAN_DRAWDOWN = 'LOAN_DRAWDOWN',
  LOAN_DRAWDOWN_REAL_ESTATE = 'LOAN_DRAWDOWN_REAL_ESTATE',
  LOAN_DRAWDOWN_PERSONAL = 'LOAN_DRAWDOWN_PERSONAL',
  LOAN_DRAWDOWN_REVOLVING = 'LOAN_DRAWDOWN_REVOLVING',
  LOAN_DRAWDOWN_FAST = 'LOAN_DRAWDOWN_FAST',
  LOAN_DRAWDOWN_STUDENT = 'LOAN_DRAWDOWN_STUDENT',
  LOAN_REPAYMENT = 'LOAN_REPAYMENT',
  LOAN_REPAYMENT_REAL_ESTATE = 'LOAN_REPAYMENT_REAL_ESTATE',
  LOAN_REPAYMENT_PERSONAL = 'LOAN_REPAYMENT_PERSONAL',
  LOAN_REPAYMENT_REVOLVING = 'LOAN_REPAYMENT_REVOLVING',
  LOAN_REPAYMENT_FAST = 'LOAN_REPAYMENT_FAST',
  LOAN_REPAYMENT_STUDENT = 'LOAN_REPAYMENT_STUDENT',
  LOAN_PREPAYMENT = 'LOAN_PREPAYMENT',
  SPLIT_PAYMENT = 'SPLIT_PAYMENT',
  BAILIFF = 'BAILIFF',
  LEASING = 'LEASING',
  DEBT_COLLECTION = 'DEBT_COLLECTION',
}

export enum TransactionSavingCategory {
  INTEREST = 'INTEREST',
  SAVING = 'SAVING',
  BANKBOOK_SAVING = 'BANKBOOK_SAVING',
  SHARE_SAVING = 'SHARE_SAVING',
}

export enum TransactionBankOperationCategory {
  REJECTION_PAYMENT = 'REJECTION_PAYMENT',
  REJECTION_LOAN_REPAYMENT = 'REJECTION_LOAN_REPAYMENT',
  REJECTION_CHECK = 'REJECTION_CHECK',
  FEES_BANK_SERVICE = 'FEES_BANK_SERVICE',
  FEES_OVERDRAFT = 'FEES_OVERDRAFT',
  FEES_UNAUTHORIZED_OVERDRAFT = 'FEES_UNAUTHORIZED_OVERDRAFT',
  FEES_CHECK_REJECTION = 'FEES_CHECK_REJECTION',
  FEES_PAYMENT_REJECTION = 'FEES_PAYMENT_REJECTION',
  FEES_INTERVENTION = 'FEES_INTERVENTION',
  FEES_INCIDENT = 'FEES_INCIDENT',
  FEES_DIRECT_DEBT_RECOVERY = 'FEES_DIRECT_DEBT_RECOVERY',
  FEES_ACCOUNT_SEIZURE = 'FEES_ACCOUNT_SEIZURE',
  FEES_PREVENTIVE_SEIZURE = 'FEES_PREVENTIVE_SEIZURE',
  REFUND_DIRECT_DEBT_RECOVERY_FEES = 'REFUND_DIRECT_DEBT_RECOVERY_FEES',
  REFUND_ACCOUNT_SEIZURE_FEES = 'REFUND_ACCOUNT_SEIZURE_FEES',
  REFUND_PREVENTIVE_SEIZURE_FEES = 'REFUND_PREVENTIVE_SEIZURE_FEES',
  REFUND_BANK_INCIDENT_FEES = 'REFUND_BANK_INCIDENT_FEES',
  RELEASE_DIRECT_DEBT_RECOVERY = 'RELEASE_DIRECT_DEBT_RECOVERY',
  RELEASE_ACCOUNT_SEIZURE = 'RELEASE_ACCOUNT_SEIZURE',
  RELEASE_PREVENTIVE_SEIZURE = 'RELEASE_PREVENTIVE_SEIZURE',
  PROVISION_DIRECT_DEBT_RECOVERY = 'PROVISION_DIRECT_DEBT_RECOVERY',
  PROVISION_ACCOUNT_SEIZURE = 'PROVISION_ACCOUNT_SEIZURE',
  PROVISION_PREVENTIVE_SEIZURE = 'PROVISION_PREVENTIVE_SEIZURE',
  CREDIT_CARD_RESET = 'CREDIT_CARD_RESET',
  REFUND_BANK_SERVICE_FEES = 'REFUND_BANK_SERVICE_FEES',
}

export enum TransactionRefundCategory {
  REFUND = 'REFUND',
  REFUND_INSURANCE = 'REFUND_INSURANCE',
  REFUND_EXPENSE_REPORT = 'REFUND_EXPENSE_REPORT',
}

export enum TransactionTaxCategory {
  PRO_TAX = 'PRO_TAX',
  PRO_TAX_REFUND = 'PRO_TAX_REFUND',
  PERSO_TAX = 'PERSO_TAX',
  INCOME_TAX = 'INCOME_TAX',
  HOUSING_TAX = 'HOUSING_TAX',
  PROPERTY_TAX = 'PROPERTY_TAX',
  PERSO_TAX_CREDIT = 'PERSO_TAX_CREDIT',
  PERSO_TAX_REFUND = 'PERSO_TAX_REFUND',
}

export type TransactionCategory =
  | TransactionIncomeCategory
  | TransactionExpenseCategory
  | TransactionCreditCategory
  | TransactionSavingCategory
  | TransactionBankOperationCategory
  | TransactionRefundCategory
  | TransactionTaxCategory;

export enum TransactionType {
  CASH_DEPOSIT = 'CASH_DEPOSIT',
  CASH_WITHDRAWAL = 'CASH_WITHDRAWAL',
  CHECK_DEPOSIT = 'CHECK_DEPOSIT',
  CHECK = 'CHECK',
  INCOMING_TRANSFER = 'INCOMING_TRANSFER',
  INCOMING_INTERNAL_TRANSFER = 'INCOMING_INTERNAL_TRANSFER',
  OUTGOING_TRANSFER = 'OUTGOING_TRANSFER',
  OUTGOING_INTERNAL_TRANSFER = 'OUTGOING_INTERNAL_TRANSFER',
  CARD = 'CARD',
  CARD_REFUND = 'CARD_REFUND',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
  INCOMING_CARD = 'INCOMING_CARD',
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
}

export interface Enrichments {
  category: TransactionCategory;
  /**
   * TODO: MIGRATION CI V1->V2
   * The type might not be available on V1, when removing support for V1 it will be available at all time
   */
  type?: TransactionType;
  isInternationalTransfer?: boolean;
  relatedTransactions?: {
    retryOf?: string;
    retriedOn?: string;
    rejectionOf?: string;
    rejectedOn?: string;
    transferOf?: string;
    transferedOn?: string;
    resetOf?: string;
    resetOn?: string;
    refundOf?: string;
    refundedOn?: string;
  };
}

export interface Transaction {
  id: string;
  accountId: string;
  dates: TransactionDates;
  description: string;
  amount: number;
  currency: string;
  enrichments?: Enrichments;
  isComing?: boolean;
  isNonAnalysed?: boolean;
  aggregator?: Aggregator;
  comment?: string;
}

/**
 * The following object is used to determine the order
 of the cashflows for each category
in the cashflow table */
export const transactionCategoryOrder: Record<TransactionCategory, number> = {
  [TransactionIncomeCategory.DISSAVING]: 0,
  [TransactionCreditCategory.LOAN_DRAWDOWN]: 10,
  [TransactionCreditCategory.LOAN_DRAWDOWN_REAL_ESTATE]: 20,
  [TransactionCreditCategory.LOAN_DRAWDOWN_PERSONAL]: 30,
  [TransactionCreditCategory.LOAN_DRAWDOWN_REVOLVING]: 40,
  [TransactionCreditCategory.LOAN_DRAWDOWN_FAST]: 50,
  [TransactionCreditCategory.LOAN_DRAWDOWN_STUDENT]: 60,
  [TransactionIncomeCategory.GAMBLING_GAIN]: 50,
  [TransactionTaxCategory.PERSO_TAX_CREDIT]: 60,
  [TransactionTaxCategory.PERSO_TAX_REFUND]: 70,
  [TransactionBankOperationCategory.REFUND_DIRECT_DEBT_RECOVERY_FEES]: 80,
  [TransactionBankOperationCategory.REFUND_ACCOUNT_SEIZURE_FEES]: 90,
  [TransactionBankOperationCategory.REFUND_PREVENTIVE_SEIZURE_FEES]: 100,
  [TransactionBankOperationCategory.RELEASE_DIRECT_DEBT_RECOVERY]: 110,
  [TransactionBankOperationCategory.RELEASE_ACCOUNT_SEIZURE]: 120,
  [TransactionBankOperationCategory.RELEASE_PREVENTIVE_SEIZURE]: 130,
  [TransactionBankOperationCategory.CREDIT_CARD_RESET]: 190,
  [TransactionRefundCategory.REFUND]: 140,
  [TransactionRefundCategory.REFUND_INSURANCE]: 150,
  [TransactionRefundCategory.REFUND_EXPENSE_REPORT]: 160,
  [TransactionTaxCategory.PRO_TAX_REFUND]: 170,
  [TransactionBankOperationCategory.REFUND_BANK_SERVICE_FEES]: 180,
  [TransactionBankOperationCategory.REFUND_BANK_INCIDENT_FEES]: 190,
  [TransactionIncomeCategory.OTHER_ENTRY]: 190,
  [TransactionSavingCategory.INTEREST]: 0,
  [TransactionIncomeCategory.WAGE]: 10,
  [TransactionIncomeCategory.WAGE_BONUS]: 20,
  [TransactionIncomeCategory.WAGE_SALARY_ADVANCE]: 30,
  [TransactionIncomeCategory.WAGE_ADVANCE_PAYMENT]: 40,
  [TransactionIncomeCategory.FREELANCE]: 41,
  [TransactionIncomeCategory.RENTAL_INCOME]: 50,
  [TransactionIncomeCategory.RECEIVED_ALIMONY]: 60,
  [TransactionIncomeCategory.RETIREMENT_PENSION]: 70,
  [TransactionIncomeCategory.REVERSIONARY_PENSION]: 80,
  [TransactionIncomeCategory.ALLOWANCE]: 90,
  [TransactionIncomeCategory.ALLOWANCE_FAMILY]: 100,
  [TransactionIncomeCategory.ALLOWANCE_HOUSING]: 110,
  [TransactionIncomeCategory.ALLOWANCE_UNEMPLOYMENT]: 120,
  [TransactionIncomeCategory.ALLOWANCE_HEALTH]: 130,
  [TransactionIncomeCategory.ALLOWANCE_DISABILITY]: 131,
  [TransactionIncomeCategory.ALLOWANCE_INCOME_SUPPORT]: 140,
  [TransactionIncomeCategory.STATE_SUBSIDY]: 150,
  [TransactionIncomeCategory.REGULAR_INCOME]: 160,
  [TransactionExpenseCategory.DEFERRED_TOTAL_PAYMENT]: 10,
  [TransactionExpenseCategory.GROCERY]: 20,
  [TransactionExpenseCategory.LEISURE]: 30,
  [TransactionExpenseCategory.SHOPPING]: 40,
  [TransactionExpenseCategory.TOBACCO]: 50,
  [TransactionExpenseCategory.GAMBLING]: 60,
  [TransactionExpenseCategory.MULTIMEDIA]: 70,
  [TransactionExpenseCategory.SPORT]: 80,
  [TransactionTaxCategory.PRO_TAX]: 90,
  [TransactionTaxCategory.PERSO_TAX]: 100,
  [TransactionTaxCategory.INCOME_TAX]: 110,
  [TransactionTaxCategory.HOUSING_TAX]: 120,
  [TransactionTaxCategory.PROPERTY_TAX]: 130,
  [TransactionExpenseCategory.HEALTH]: 140,
  [TransactionBankOperationCategory.FEES_BANK_SERVICE]: 150,
  [TransactionBankOperationCategory.FEES_INCIDENT]: 160,
  [TransactionBankOperationCategory.FEES_OVERDRAFT]: 170,
  [TransactionBankOperationCategory.FEES_UNAUTHORIZED_OVERDRAFT]: 175,
  [TransactionBankOperationCategory.FEES_CHECK_REJECTION]: 180,
  [TransactionBankOperationCategory.FEES_PAYMENT_REJECTION]: 190,
  [TransactionBankOperationCategory.FEES_INTERVENTION]: 200,
  [TransactionBankOperationCategory.FEES_DIRECT_DEBT_RECOVERY]: 210,
  [TransactionBankOperationCategory.FEES_ACCOUNT_SEIZURE]: 220,
  [TransactionBankOperationCategory.FEES_PREVENTIVE_SEIZURE]: 230,
  [TransactionBankOperationCategory.PROVISION_DIRECT_DEBT_RECOVERY]: 240,
  [TransactionBankOperationCategory.PROVISION_ACCOUNT_SEIZURE]: 250,
  [TransactionBankOperationCategory.PROVISION_PREVENTIVE_SEIZURE]: 260,
  [TransactionExpenseCategory.OTHER_EXPENSE]: 300,
  [TransactionExpenseCategory.REGULAR_EXPENSE]: 90,
  [TransactionExpenseCategory.INSURANCE]: 50,
  [TransactionExpenseCategory.INSURANCE_HEALTH]: 60,
  [TransactionExpenseCategory.INSURANCE_AUTO]: 70,
  [TransactionExpenseCategory.INSURANCE_HOME]: 80,
  [TransactionExpenseCategory.INSURANCE_LOAN]: 81,
  [TransactionExpenseCategory.TRANSPORT]: 40,
  [TransactionExpenseCategory.RENT]: 10,
  [TransactionExpenseCategory.POWER]: 20,
  [TransactionExpenseCategory.TELECOM]: 30,
  [TransactionExpenseCategory.PAID_ALIMONY]: 140,
  [TransactionExpenseCategory.CARD_PAYMENT]: 11,
  [TransactionExpenseCategory.ATM]: 21,
  [TransactionExpenseCategory.CHECK]: 31,
  [TransactionCreditCategory.LOAN_REPAYMENT]: 10,
  [TransactionCreditCategory.LOAN_REPAYMENT_REAL_ESTATE]: 20,
  [TransactionCreditCategory.LOAN_REPAYMENT_PERSONAL]: 30,
  [TransactionCreditCategory.LOAN_REPAYMENT_REVOLVING]: 40,
  [TransactionCreditCategory.LOAN_REPAYMENT_FAST]: 50,
  [TransactionCreditCategory.LOAN_REPAYMENT_STUDENT]: 60,
  [TransactionCreditCategory.LOAN_PREPAYMENT]: 50,
  [TransactionCreditCategory.SPLIT_PAYMENT]: 60,
  [TransactionCreditCategory.DEBT_COLLECTION]: 70,
  [TransactionCreditCategory.BAILIFF]: 80,
  [TransactionCreditCategory.LEASING]: 90,
  [TransactionSavingCategory.SAVING]: 0,
  [TransactionSavingCategory.BANKBOOK_SAVING]: 0,
  [TransactionSavingCategory.SHARE_SAVING]: 0,
  [TransactionBankOperationCategory.REJECTION_CHECK]: 0,
  [TransactionBankOperationCategory.REJECTION_LOAN_REPAYMENT]: 0,
  [TransactionBankOperationCategory.REJECTION_PAYMENT]: 0,
};

export const categoriesExcludedFromCashFlowTable: TransactionCategory[] = [
  TransactionIncomeCategory.DISSAVING,
  TransactionSavingCategory.SAVING,
  TransactionSavingCategory.SHARE_SAVING,
  TransactionSavingCategory.BANKBOOK_SAVING,
  TransactionBankOperationCategory.REJECTION_CHECK,
  TransactionBankOperationCategory.REJECTION_LOAN_REPAYMENT,
  TransactionBankOperationCategory.REJECTION_PAYMENT,
  TransactionBankOperationCategory.CREDIT_CARD_RESET,
];

export const typesExcludedFromCashFlowTable: TransactionType[] = [
  TransactionType.OUTGOING_INTERNAL_TRANSFER,
  TransactionType.INCOMING_INTERNAL_TRANSFER,
];

export const incidentsTransactionCategories: TransactionCategory[] = [
  TransactionCreditCategory.BAILIFF,
  TransactionBankOperationCategory.FEES_INTERVENTION,
  TransactionBankOperationCategory.FEES_DIRECT_DEBT_RECOVERY,
  TransactionBankOperationCategory.PROVISION_ACCOUNT_SEIZURE,
  TransactionBankOperationCategory.PROVISION_DIRECT_DEBT_RECOVERY,
  TransactionBankOperationCategory.REJECTION_PAYMENT,
  TransactionBankOperationCategory.REJECTION_LOAN_REPAYMENT,
  TransactionBankOperationCategory.REJECTION_CHECK,
];
